module.exports = __webpack_public_path__ + "img/travel_black_circle_icon.9e394095.svg";